export default __webpack_public_path__ + "static/media/05-large.29cbcfc8.jpg";